export enum ProductRegistrationRequestStatusEnum {
  Pending = 'Pending',
  Analysis = 'Analysis',
  Approved = 'Approved',
  Rejected = 'Rejected'
}

export enum SorterEnum {
  ASC,
  DESC
}
